<!--
 * @Author: Latte
 * @Date: 2021-08-04 14:42:27
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-07 10:12:51
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\MyTable\index.vue
-->
<template>
  <div class="app-container">
    <!-- 工具栏 -->
    <my-toolbar
      v-if="configuration.hasToolbar === true"
      v-on="$listeners"
      :btnLabel="conf.btnLabel"
    ></my-toolbar>

    <!-- 表格 -->
    <el-table
      ref="table"
      :data="tableData"
      :border="tableOpt.border"
      :stripe="tableOpt.stripe"
      style="width: 100%; margin-bottom: 20px"
      :header-cell-style="tableOpt.tabStyle"
      v-bind="$attrs"
    >
      <div v-for="item in configuration.tableColumnOpt" :key="item.prop">
        <!-- 有子列表 item.type = 'expand' -->
        <el-table-column
          v-if="item.type === 'expand'"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
          :header-align="item.headerAlign || 'center'"
          :align="item.align || 'center'"
        >
          <template slot-scope="scope">
            <slot :name="item.slotName" :child="scope.row"></slot>
          </template>
        </el-table-column>

        <!-- 有过滤器 item.hasFilter = 'true' -->
        <el-table-column
          v-else-if="item.hasFormatter"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
          :header-align="item.headerAlign || 'center'"
          :align="item.align || 'center'"
        >
          <template slot-scope="scope">
            <div>{{ item.formatter(scope.row[scope.column.property]) }}</div>
          </template>
        </el-table-column>

        <!-- 无子列表 item.type != 'expand' -->
        <el-table-column
          v-else
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
          :header-align="item.headerAlign || 'center'"
          :align="item.align || 'center'"
        ></el-table-column>
      </div>

      <!-- 状态 -->
      <el-table-column
        v-if="configuration.hasStatus"
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          <slot name="status" :data="scope.row"></slot>
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column
        v-if="configuration.hasOperation"
        label="操作"
        align="center"
        :width="configuration.operationWidth || '500'"
      >
        <template slot-scope="scope">
          <slot name="operation" :data="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <my-pagination></my-pagination>
  </div>
</template>

<script>
import MyPagination from "@/components/MyTable/MyPagination/index";
import MyToolbar from "@/components/MyTable/MyToolbar/index";
export default {
  name: "myTable",
  components: {
    MyPagination,
    MyToolbar,
  },

  props: {
    //表格默认参数 (一般使用默认配置，非特殊情况不用传参)
    tableOpt: {
      type: Object,
      default: function () {
        return {
          border: true, // 是否需要边框
          stripe: true, // 斑马纹
          tabStyle: {
            // 表格样式
            blackground: "#F5F7FA",
          },
        };
      },
    },

    // 表格数据
    tableData: {
      type: [Array, Object],
      default: function () {
        return [];
      },
    },

    // mytable配置
    conf: {
      type: Object,
      default: () => {
        return {
          // 是否显示工具栏
          hasToolbar: {
            type: Boolean,
            default: true,
          },
          //表格配置参数
          tableColumnOpt: {
            type: Array,
            default: function () {
              return [
                {
                  type: "", //单元格类型
                  prop: "", //单元格数据
                  label: "", //单元格标题
                  width: "", //单元格宽度
                  headerAlign: "center", //表头是否居中
                  align: "center", //内容是否居中
                },
              ];
            },
          },
          // 是否显示状态栏
          hasStatus: true,
          //是否显示操作栏
          hasOperation: true,
          // 操作栏宽度
          operationWidth: "500",
        };
      },
    },
  },

  computed: {
    // 由于不能给props里的对象设置默认值，用computed代替
    configuration() {
      return Object.assign(
        {
          // 是否显示工具栏
          hasToolbar: false,
          // 工具栏按钮名称
          btnLabel: '',
          //表格配置参数
          tableColumnOpt: {
            type: "", //单元格类型
            prop: "", //单元格数据
            label: "", //单元格标题
            width: "", //单元格宽度
            headerAlign: "center", //表头是否居中
            align: "center", //内容是否居中
          },
          // 是否显示状态栏
          hasStatus: true,
          //是否显示操作栏
          hasOperation: true,
          // 操作栏宽度
          operationWidth: "500",
        },
        this.conf
      );
    },
  },
};
</script>

<style>
</style>